export class SelectedReport {

    sourceEnvironment: string;
    targetEnvironment: string;
    sourceObjectURI: string;
    targetObjectURI: string;
    
    constructor(sourceEnvironment: string, targetEnvironment: string, sourceObjectURI: string, targetObjectURI: string) {
        this.sourceEnvironment = sourceEnvironment;
        this.targetEnvironment = targetEnvironment;
        this.sourceObjectURI = sourceObjectURI;
        this.targetObjectURI = targetObjectURI;
    }
}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/model/SelectedReport.ts